<template>
    <div class="contenido-principal">
        <Menu :token="token" @salir="cerrarSesion"/>
    
        <div>
          <transition name="fade" mode="out-in">
            <router-view  />
          </transition>
        </div>
    
        <Pie />
    </div>
</template>

<script>
import {mapState, mapActions} from 'vuex'
import axios from 'axios'
import Menu from '@/modules/colonos/components/Menu.vue'
import Pie from '@/modules/colonos/components/Pie.vue'

export default {
    name: 'ColonosLayout',
    components: {
        Menu, Pie
    },
    created () {
        this.traerParametros()
        this.cargarLocalStorage()
    },
    mounted () {

    },
    watch: {
      $route(to) {
          document.title = to.meta.title || this.titulo;
      },
    },
    data () {
        return {
            titulo: 'Fraccionamientos'
        }
    },
    methods: {
        traerParametros() {
            const formData = new FormData();
            formData.append("accion", "mostrarDatos");
            formData.append("tabla", "parametros");
            formData.append("limite", 1);

            axios.post(`${this.url}/ajax/ajax.generico.php`, formData)
            .then((res) => {
                this.titulo = res.data.razonsocial
            });
        },
        cerrarSesion() {
            var formData = new FormData();
            formData.append("accion", "cerrarSesion");
            formData.append("idUsuario", this.idUsuario)
            
            axios.post(`${this.url}/ajax/ajax.usuarios.php`, formData)
            .then(res => {
                if (res.data == 'ok') {
                    let usuario = {
                    token: '',
                    idUsuario: '',
                    tipoUsuario: '',
                    ciw: '',
                    emailUsuario: ''
                    }
                    
                    this.updUsuario(usuario)

                    localStorage.clear()
                    this.$router.push(`/inicio`).catch(error => {
                        // Ignore navigation duplicated errors
                        if (error.name !== 'NavigationDuplicated') {
                            throw error;
                        }
                    })
                }
            });
        },
        ...mapActions(['cargarLocalStorage', 'updUsuario'])
    },
    computed: {
        url() {
            if ( ["localhost", "127.0.0.1", ""].includes(window.location.hostname) ) {
                return this.urlSandbox
            } else {
                return this.urlProd
            }
        },
        ...mapState(['urlProd', 'urlSandbox', 'token', 'idUsuario'])
    }
}

</script>